import { render, staticRenderFns } from "./ListDocumentsFeatured.vue?vue&type=template&id=7b5b46fe&scoped=true&"
import script from "./ListDocumentsFeatured.vue?vue&type=script&lang=js&"
export * from "./ListDocumentsFeatured.vue?vue&type=script&lang=js&"
import style0 from "./ListDocumentsFeatured.vue?vue&type=style&index=0&id=7b5b46fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5b46fe",
  null
  
)

export default component.exports